import DefaultValuesUtils from "./DefaultValuesUtils";

/**
 * Class responsible for general functions in the system.
 * 
 * @class DefaultFunctionsUtils
 * @example
 * const routeIndex = DefaultFunctionsUtils.getSelectedIndexRouteByPath();
 * console.log(routeIndex); // keyof DefaultValuesUtils.ROUTES
 */
class DefaultFunctionsUtils {
  /**
   * 
   * @returns {number} - The route index related to the path on URL
   */
  static getSelectedIndexRouteByPath() {
    const routeName = `${window.location.pathname}${window.location.search}`;
    const preIndex = Object.entries(DefaultValuesUtils.ROUTES).find(([, value]) => value === routeName);
    const routeIndex = preIndex ? parseInt(preIndex) : 0;
    return routeIndex === 100 ? 0 : routeIndex;
  }

  /**
   * 
   * @param {ReactRouterDom.History} history - The history object to redirect users to pages
   * @param {string} search? - The search param in the URL
   * @param {number as keyof DefaultValuesUtils.ROUTES} index - The URL index in the routes map
   */
  static redirectToTicketsPage(history, search = "", index = 0) {
    localStorage.setItem("selectedIndexRoute", index);
    history.push(`${DefaultValuesUtils.ROUTES[100]}${search}`);
  }

  /**
   * 
   * @param {Message} message - The chat message
   * @param {string} targetPropertyKey - The target property to fetch (DefaultValuesUtils.MESSAGE_PROPERTIES.KEYS)
   * @returns {MessageProperty | undefined} - The filtered MessageProperty or undefined when property is not found
   */
  static extractMessageProperty(message, targetPropertyKey) {
    return message.messageProperties?.find(property => property.propertyKey === targetPropertyKey);
  }
}

export default DefaultFunctionsUtils;
